import React, { memo } from 'react'

const publicUrl = process.env.PUBLIC_URL || ''
const base = `${publicUrl}/images/hero`

const avifSrcSet = `${base}/hero-640.avif 640w, ${base}/hero-828.avif 828w, ${base}/hero-1280.avif 1280w, ${base}/hero-1920.avif 1920w`
const webpSrcSet = `${base}/hero-640.webp 640w, ${base}/hero-828.webp 828w, ${base}/hero-1280.webp 1280w, ${base}/hero-1920.webp 1920w`

function HeroBackground() {
  return (
    <picture className="parallax-header__media">
      <source type="image/avif" srcSet={avifSrcSet} sizes="100vw" />
      <source type="image/webp" srcSet={webpSrcSet} sizes="100vw" />
      <img
        className="parallax-header__img"
        src={`${base}/hero-1280.webp`}
        srcSet={webpSrcSet}
        sizes="100vw"
        width={1984}
        height={1024}
        alt="Tropical beach scene with colorful drinks, Reggae Wheels Jamaica travel"
        fetchPriority="high"
        decoding="async"
      />
    </picture>
  )
}

export default memo(HeroBackground)
